import EmailPreferences from "components/EmailPreferences/EmailPreferences";

const ClinicEmailPreferences = () => {
    return (
        <EmailPreferences />
    )
}

export default ClinicEmailPreferences;
